import { Close } from '@radix-ui/react-dialog'
import type { ComponentPropsWithoutRef } from 'react'

export type DialogCloseProps = ComponentPropsWithoutRef<typeof Close>

export const DialogClose = Close
